import $ from 'jquery'

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    $('.input-item-input').on('mouseover', function () {
      $(this).addClass('input-item-hover');
    });
    $('.input-item-input').on('mouseleave', function () {
      $(this).removeClass('input-item-hover');
    })
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplateCorporateBankingAccounts.js